import { AppNS } from 'app';

import { parseReportInspections } from '../common-parsers/common-parsers';

export const parseReport = (reportData: AppNS.Params): AppNS.JobEventReport => {
  const output = {
    ...reportData,
    eventInspections: parseReportInspections(reportData.eventInspections),
  } as AppNS.JobEventReport;
  return output;
};
